<template>
  <div>
    <Manual />
  </div>
</template>

<script>
import Manual from '@/components/Manual.vue'

export default {
  components: {
    Manual
  }
}
</script>
